import React, { useState } from 'react';
import { Filter, ChevronUp, ChevronDown, List, BarChart3, Globe, Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
export function StationFilters() {
  const [isOpen, setIsOpen] = useState(true);
  return <div className="absolute top-6 left-6 z-[1000] w-[300px] rounded-2xl border border-white/[0.08] shadow-2xl shadow-black/40 flex flex-col overflow-hidden" style={{
    background: 'rgba(15, 23, 42, 0.55)',
    backdropFilter: 'blur(40px) saturate(180%)',
    WebkitBackdropFilter: 'blur(40px) saturate(180%)'
  }} data-id="element-1023">
      {/* Inner glow border effect */}
      <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
      background: 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, transparent 50%, rgba(255,255,255,0.02) 100%)'
    }} data-id="element-1024" />

      {/* Header */}
      <div className="relative flex items-center justify-between p-4 border-b border-white/[0.06] cursor-pointer hover:bg-white/[0.03] transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-1025">
        <div className="flex items-center gap-2 text-white/90 font-medium" data-id="element-1026">
          <Filter size={16} className="text-white/60" data-id="element-1027" />
          <span data-id="element-1028">Station Filters</span>
        </div>
        {isOpen ? <ChevronUp size={16} className="text-white/40" data-id="element-1029" /> : <ChevronDown size={16} className="text-white/40" data-id="element-1030" />}
      </div>

      {isOpen && <div className="relative p-4 space-y-5" data-id="element-1031">
          {/* Region Selection */}
          <div className="space-y-3" data-id="element-1032">
            <div className="flex items-center gap-2 text-xs font-medium text-white/50 uppercase tracking-wider" data-id="element-1033">
              <div className="h-2.5 w-2.5 rounded-full bg-[#EC4899] shadow-[0_0_6px_rgba(236,72,153,0.4)]" data-id="element-1034" />
              Region Selection
            </div>
            <div className="flex items-center gap-2" data-id="element-1035">
              <Button variant="outline" className="flex-1 justify-center gap-2 text-white/80 border-white/[0.1] bg-white/[0.06] hover:bg-white/[0.1] h-9 text-sm rounded-lg" data-id="element-1036">
                <Globe size={14} data-id="element-1037" />
                Select Region
              </Button>
              <Button variant="primary" className="justify-center gap-1.5 bg-red-500/70 hover:bg-red-500/90 text-white h-9 text-sm px-3 shadow-none rounded-lg" data-id="element-1038">
                <Trash2 size={14} data-id="element-1039" />
                Clear
              </Button>
            </div>
          </div>

          {/* Stats */}
          <div className="space-y-1.5" data-id="element-1040">
            <div className="flex justify-between text-sm" data-id="element-1041">
              <span className="text-white/45" data-id="element-1042">Filtered:</span>
              <span className="font-bold text-white" data-id="element-1043">292</span>
            </div>
            <div className="flex justify-between text-sm" data-id="element-1044">
              <span className="text-white/45" data-id="element-1045">Total:</span>
              <span className="font-medium text-white/70" data-id="element-1046">9772</span>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3 pt-1" data-id="element-1047">
            <Button className="w-full gap-2 bg-[#EC4899]/90 hover:bg-[#EC4899] text-white shadow-lg shadow-pink-500/20 h-10 rounded-lg" data-id="element-1048">
              <List size={16} data-id="element-1049" />
              View Stations (292)
            </Button>
            <Button variant="outline" className="w-full gap-2 text-[#EC4899] border-[#EC4899]/30 hover:border-[#EC4899]/50 hover:bg-[#EC4899]/[0.06] h-10 rounded-lg" data-id="element-1050">
              <BarChart3 size={16} data-id="element-1051" />
              Compute Benchmarks
            </Button>
          </div>
        </div>}
    </div>;
}